import { TFunction } from 'hooks/useI18n';
import { SectionHeroDataProps } from '../shared/sectionHero/SectionHero.types';
import {
  GenderByRoleDataProps,
  GenderSalaryByExperienceDataProps,
  GenderSalaryByRoleAndExperienceDataProps,
  GenderSalaryByRoleDataProps,
  RepresentationDataProps
} from './Gender.types';

export const HERODATA = (t: TFunction): SectionHeroDataProps[] => [
  {
    value: '46.5%',
    desc: t('mandecar23.gender.hero.key-point-1')
  },
  {
    value: '20%',
    desc: t('mandecar23.gender.hero.key-point-2')
  },
  {
    value: '4.5%',
    desc: t('mandecar23.gender.hero.key-point-3')
  },
  {
    value: '+10K',
    desc: t('mandecar23.gender.hero.key-point-4')
  }
];

export const REPRESENTATIONDATA = (t: TFunction): RepresentationDataProps[] => [
  {
    value: t('mandecar23.gender.representation.product-design')
  },
  {
    value: t('mandecar23.gender.representation.product-management')
  },
  {
    value: t('mandecar23.gender.representation.testing')
  },
  {
    value: t('mandecar23.gender.representation.data-analysis')
  }
];

export const GENDERBYROLE: GenderByRoleDataProps[] = [
  {
    role: 'Software Architect',
    male: 95.15320334261838,
    female: 4.846796657381615
  },
  {
    role: 'Data Engineer',
    male: 91.93302891933028,
    female: 8.06697108066971
  },
  {
    role: 'Project & Delivery Manager',
    male: 78.89699179580674,
    female: 21.103008204193255
  },
  {
    role: 'SysAdmin',
    male: 94.89311163895488,
    female: 5.10688836104513
  },
  {
    role: 'Frontend Developer',
    male: 83.53099400904756,
    female: 16.46900599095244
  },
  {
    role: 'DevOps & Infra. & SRE',
    male: 94.73150962512665,
    female: 5.268490374873354
  },
  {
    role: 'Product Design (UI/UX)',
    male: 53.53946297803092,
    female: 46.46053702196908
  },
  {
    role: 'Backend Developer',
    male: 90.82913421896473,
    female: 9.170865781035273
  },
  {
    role: 'Full-stack Developer',
    male: 89.0555622224889,
    female: 10.9444377775111
  },
  {
    role: 'Data Analysis & BI',
    male: 79.91137370753324,
    female: 20.088626292466767
  },
  {
    role: 'QA & Testing Engineer',
    male: 75.4950495049505,
    female: 24.504950495049506
  },
  {
    role: 'Tech Lead',
    male: 95.45085296506905,
    female: 4.54914703493095
  },
  {
    role: 'Product Manager',
    male: 75.97809076682316,
    female: 24.02190923317684
  },
  {
    role: 'Engineering Management',
    male: 93.23636363636363,
    female: 6.763636363636364
  },
  {
    role: 'Data Scientist',
    male: 85.79925650557621,
    female: 14.200743494423792
  },
  {
    role: 'Mobile Developer',
    male: 91.1044776119403,
    female: 8.895522388059701
  }
];

export const GENDERSALARYBYROLE: GenderSalaryByRoleDataProps[] = [
  {
    role: 'Backend Developer',
    male: 42.690946714950854,
    female: 35.83847736625515
  },
  {
    role: 'Data Analysis & BI',
    male: 43.10796545105566,
    female: 39.60674157303371
  },
  {
    role: 'Data Engineer',
    male: 48.724137931034484,
    female: 44.375
  },
  {
    role: 'Data Scientist',
    male: 44.569882777276824,
    female: 40.66576086956522
  },
  {
    role: 'DevOps & Infra. & SRE',
    male: 52.66135239142386,
    female: 44.275
  },
  {
    role: 'Engineering Management',
    male: 66.90901771336554,
    female: 55.583333333333336
  },
  {
    role: 'Frontend Developer',
    male: 37.78265121877821,
    female: 30.942012288786483
  },
  {
    role: 'Full-stack Developer',
    male: 40.55297372060858,
    female: 32.314752252252255
  },
  {
    role: 'Mobile Developer',
    male: 43.1684599865501,
    female: 35.10763888888889
  },
  {
    role: 'Product Design (UI/UX)',
    male: 38.465299684542586,
    female: 32.772401433691755
  },
  {
    role: 'Product Manager',
    male: 55.731374606505774,
    female: 47.85099337748344
  },
  {
    role: 'Project & Delivery Manager',
    male: 54.465842167255595,
    female: 44.888520971302434
  },
  {
    role: 'QA & Testing Engineer',
    male: 41.011804384485664,
    female: 37.47948717948718
  },
  {
    role: 'Software Architect',
    male: 58.896021699819165,
    female: 52.877906976744185
  },
  {
    role: 'SysAdmin',
    male: 42.550064184852374,
    female: 39.96511627906977
  },
  {
    role: 'Tech Lead',
    male: 61.939321444106135,
    female: 57.25675675675676
  }
];

export const GENDERSALARYBYROLEANDEXPERIENCE: GenderSalaryByRoleAndExperienceDataProps[] =
  [
    {
      role: 'Backend Developer',
      tier4: {
        male: 55.19810201660736,
        female: 46.98701298701299
      },
      tier1: {
        male: 27.769024970273485,
        female: 26.962897526501767
      },
      tier2: {
        male: 38.75862794612795,
        female: 35.720408163265304
      },
      tier3: {
        male: 48.80599016540008,
        female: 47.86111111111111
      }
    },
    {
      role: 'Full-stack Developer',
      tier4: {
        male: 54.56666666666666,
        female: 45.50595238095238
      },
      tier1: {
        male: 27.274016763378466,
        female: 26.405144694533764
      },
      tier2: {
        male: 38.09439608269859,
        female: 34.791666666666664
      },
      tier3: {
        male: 48.14869077306734,
        female: 44.43877551020408
      }
    },
    {
      role: 'Frontend Developer',
      tier4: {
        male: 52.36410984848485,
        female: 43.36363636363636
      },
      tier1: {
        male: 26.676089517078914,
        female: 25.890396659707722
      },
      tier2: {
        male: 36.661512027491405,
        female: 34.365994236311245
      },
      tier3: {
        male: 48.076780415430264,
        female: 43.41880341880342
      }
    },
    {
      role: 'Mobile Developer',
      tier4: {
        male: 56.36882716049383,
        female: 49.666666666666664
      },
      tier1: {
        male: 26.48148148148148,
        female: 26.090909090909093
      },
      tier2: {
        male: 39.85410764872521,
        female: 38.4
      },
      tier3: {
        male: 51.716748768472904,
        female: 47.891304347826086
      }
    },
    {
      role: 'Software Architect',
      tier4: {
        male: 66.1820330969267,
        female: 56.027027027027025
      },
      tier1: {
        male: 30.4126213592233,
        female: 27.625
      },
      tier2: {
        male: 45.34334763948498,
        female: 49.63157894736842
      },
      tier3: {
        male: 60.44761904761904,
        female: 59.029411764705884
      }
    },
    {
      role: 'DevOps & Infrastructure & SRE',
      tier4: {
        male: 61.81103448275862,
        female: 52.8235294117647
      },
      tier1: {
        male: 31.286885245901637,
        female: 30.416666666666668
      },
      tier2: {
        male: 44.46782841823057,
        female: 44.31818181818181
      },
      tier3: {
        male: 55.22222222222222,
        female: 50.473684210526315
      }
    },
    {
      role: 'SysAdmin',
      tier4: {
        male: 49,
        female: 42.9
      },
      tier1: {
        male: 30.26875,
        female: 25.125
      },
      tier2: {
        male: 36.625,
        female: 36.208333333333336
      },
      tier3: {
        male: 43.28,
        female: 42.25
      }
    },
    {
      role: 'Product Design (UI/UX)',
      tier4: {
        male: 45.3563829787234,
        female: 40.29113924050633
      },
      tier1: {
        male: 29.141509433962263,
        female: 26.248175182481752
      },
      tier2: {
        male: 33.875,
        female: 33.44886363636364
      },
      tier3: {
        male: 42.29936305732484,
        female: 37.94
      }
    },
    {
      role: 'Product Manager',
      tier4: {
        male: 63.30656934306569,
        female: 55.01546391752578
      },
      tier1: {
        male: 32.34444444444445,
        female: 37
      },
      tier2: {
        male: 47.62041884816754,
        female: 40.90860215053763
      },
      tier3: {
        male: 54.49813432835821,
        female: 50.00588235294118
      }
    },
    {
      role: 'Data Analysis & BI',
      tier4: {
        male: 56.58582089552239,
        female: 48.78
      },
      tier1: {
        male: 30.12200956937799,
        female: 32.525862068965516
      },
      tier2: {
        male: 41.45525291828794,
        female: 39.098684210526315
      },
      tier3: {
        male: 48.66571428571428,
        female: 44.576086956521735
      }
    },
    {
      role: 'QA & Testing Engineer',
      tier4: {
        male: 52.9568345323741,
        female: 47.77906976744186
      },
      tier1: {
        male: 27.61764705882353,
        female: 31.62121212121212
      },
      tier2: {
        male: 38.85151515151515,
        female: 32.79
      },
      tier3: {
        male: 47.61693548387097,
        female: 42.05952380952381
      }
    },
    {
      role: 'Project Manager & Delivery Manager',
      tier4: {
        male: 59.46821392532795,
        female: 53.86312849162011
      },
      tier1: {
        male: 30.99,
        female: 28.387096774193548
      },
      tier2: {
        male: 43.97945205479452,
        female: 38.10952380952381
      },
      tier3: {
        male: 51.599489795918366,
        female: 44.07943925233645
      }
    },
    {
      role: 'Data Scientist',
      tier4: {
        male: 62.45744680851064,
        female: 52.44
      },
      tier1: {
        male: 31.55952380952381,
        female: 33.31111111111111
      },
      tier2: {
        male: 43.94883040935673,
        female: 40.80508474576271
      },
      tier3: {
        male: 53.0175,
        female: 49.392857142857146
      }
    },
    {
      role: 'Data Engineer',
      tier4: {
        male: 62.960481099656356,
        female: 52.5625
      },
      tier1: {
        male: 33.03061224489796,
        female: 38.1764705882353
      },
      tier2: {
        male: 44.668181818181814,
        female: 38.833333333333336
      },
      tier3: {
        male: 55.182,
        female: 56.166666666666664
      }
    },
    {
      role: 'Engineering Management',
      tier4: {
        male: 71.75272727272728,
        female: 60.39
      },
      tier1: {
        male: 35.766666666666666,
        female: 34.3524
      },
      tier2: {
        male: 46.39325842696629,
        female: 40.94444444444444
      },
      tier3: {
        male: 63.70229007633588,
        female: 51.130434782608695
      }
    },
    {
      role: 'Tech Lead',
      tier4: {
        male: 65.87335398915569,
        female: 56.28431372549019
      },
      tier1: {
        male: 35.76086956521739,
        female: 28.3
      },
      tier2: {
        male: 49.4712389380531,
        female: 51.333333333333336
      },
      tier3: {
        male: 59.89817415730337,
        female: 56.58536585365854
      }
    }
  ];

export const GENDERSALARYBYEXPERIENCE: GenderSalaryByExperienceDataProps[] = [
  {
    exp: '<2y',
    male: 27.957399810665827,
    female: 27.24889135254989
  },
  {
    exp: '2-5y',
    male: 39.75275891341256,
    female: 35.66969972702457
  },
  {
    exp: '5-10y',
    male: 51.24115684093437,
    female: 44.286013986013984
  },
  {
    exp: '>10y',
    male: 59.706073371950154,
    female: 49.361420612813376
  }
];
